export default "__VITE_ASSET__52011320__"